import {
    apiRequest,
    processInput
} from "@/utilities"

export const coachReferralSourceService = {
    async getCoachReferralSources() {
        const getCoachReferralSourcesRequest = {
            method: "GET"
        }
        return await apiRequest("/api/coach-referral-sources", getCoachReferralSourcesRequest)
    },
    async getCoachReferralSource(uuid) {
        const getCoachReferralSourceRequest = {
            method: "GET"
        }
        return await apiRequest(`/api/coach-referral-sources/${uuid}`, getCoachReferralSourceRequest)
    },
    async createCoachReferralSource(params) {
        const createData = processInput(params)
        const createCoachReferralSourceRequest = {
            method: "POST",
            data: createData
        }
        return await apiRequest("/api/coach-referral-sources", createCoachReferralSourceRequest)
    },
    async editCoachReferralSource(params) {
        const { uuid } = params
        delete params.uuid
        let data = processInput(params)
        data.append("_method", "PATCH")
        const editCoachReferralSourceRequest = {
            method: "POST",
            data
        }
        return await apiRequest(`/api/coach-referral-sources/${uuid}`, editCoachReferralSourceRequest)
    },
    async deleteCoachReferralSource(uuid) {
        const deleteCoachReferralSourceRequest = {
            method: "DELETE"
        }
        return await apiRequest(`/api/coach-referral-sources/${uuid}`, deleteCoachReferralSourceRequest)
    }
}